import { createReducer } from '@reduxjs/toolkit'
import { activityHistoryActions } from '@store/reducers/manager/activityHistory/actions'
import type {
  ActivityHistoryAction,
  ActivityHistoryState,
} from '@store/reducers/manager/activityHistory/types'

export const initialActivityHistoryState: ActivityHistoryState = {
  isLoading: false,
  selectedActionId: null,
  actions: [],
  total: 0,
}

export const activityHistoryReducer = createReducer<ActivityHistoryState>(
  initialActivityHistoryState,
  (builder) =>
    builder
      .addCase(activityHistoryActions.setIsLoading, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(activityHistoryActions.setIsLoaded, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(
        activityHistoryActions.setActivityHistorySelectedAction,
        (state, { payload }) => ({
          ...state,
          selectedActionId: payload,
        })
      )
      .addCase(
        activityHistoryActions.setActivityHistoryTotal,
        (state, { payload }) => ({
          ...state,
          total: payload,
        })
      )
      .addCase(
        activityHistoryActions.addActivityHistoryActions,
        (state, { payload: { actions } }) => ({
          ...state,
          actions: actions
            .reduce(
              (acc, action) => {
                if (!acc.find((a) => a.id === action.id)) {
                  acc.push(action)
                }

                return acc
              },
              [...state.actions] as ActivityHistoryAction[]
            )
            .sort((a, b) => {
              return b.id - a.id
            }),
        })
      )
      .addCase(activityHistoryActions.resetActivityHistory, (_) => {
        return initialActivityHistoryState
      })
)
